module.exports = __webpack_public_path__ + "img/levelup-products-circle.171f8687.svg";